export const ENGINE_POWER_BURST_CONFIG = {
  opacity: 1,
  // Shader seconds: 0.6 playback gives a 4s burst per stomp.
  playbackRate: 0.6,
  duration: 2.4,
};
